import React from "react";
import Summary from "./Summary/Summary";
import BackSummary from "./Summary/ExpertsSummary/BackSummary";

export default function Component(props) {
  const {
    handleReport,
    getAssessmentReportByEmpIDData,
    crrSelectedEmp,
    createdAt,
    EditButtonFn,
    EditDetailsFn,
    handleSummaryReport,
    getTheme,
    loading,


    backSummary,
    handleShowMainSummaryModal,
    handleShowMainSummaryModalBack,
    contactExpertSection,
    handleExpertContactModal,
    topFiveTalent,
    handleExpertContactModalBack,
    crrDetail,
    crrCodeUserDetails,
    handleInputExpertForm,
    bookExpert,
    userAssessmentExpertOrderPlaceData,
    handleTestPayment,
    showMyExpertList,

    getExpertOrderBookListData


  } = props;

  // console.log('createdAtcreatedAtcreatedAtcreatedAtcreatedAtcreatedAtcreatedAtcreatedAt', createdAt);
  // console.log('backSummary--------------------->', backSummary)


  function getModifiedContent(text) {
    let text2 = "";
    if (text) {
      text2 = text
        .replace(/<\/?li[^>]*>/g, "@")
        .replace(/<\/?ul[^>]*>/g, "")
        .replace(/<\/?span[^>]*>/g, "")
        .replace(/<\/?p[^>]*>/g, "")
        .replace("&nbsp;", "")
        .replace(/<\/?br[^>]*>/g, "")
        .replace(/<\/?b[^>]*>/g, "");
    }
    return text2 ? text2 : text;
  }

  function getBulletPoints(element, field) {
    let descX =
      element && element.details && element.details[field]
        ? element.details[field]
        : "";
    let descNew = "";
    if (descX) {
      let temp = getModifiedContent(descX);
      console.log("descX", descX);
      console.log("temp", temp);
      descNew = temp.split("@").filter((prev) => prev !== "");
      // console.log("descNew",descNew)
    }
    return descNew;
  }

  function getTitle(element, type) {
    let itemName =
      type === 1
        ? "How to use - every day?"
        : "How to deal with a person who has - talent?";
    let final = itemName.replace("-", element.dimension.trim());
    console.log("final--->", final.toString());
    return final.toString();
  }

  const cirleColor = (element) => {
    return (
      <span
        style={{
          background:
            element && element.colorCode ? element.colorCode : "#DDDDDD",
        }}
        className={"w-5 h-5 rounded-full "}
      />
    );
  };

  function hexToRgbA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return (
        "rgba(" +
        [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
        "," +
        opacity +
        ")"
      );
    }
    throw hex;
  }

  function chunkList(array) {
    const chunkSize = 7;
    let list = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      const chunk = array.slice(i, i + chunkSize);
      list.push(chunk);
    }
    console.log("list--->", list);
    return list;
  }

  function getWeightage(rank) {
    let value = 0;
    value = 22 - rank;
    return value
  }

  let getAssessmentDimensionsData = [];

  if (getAssessmentReportByEmpIDData && getAssessmentReportByEmpIDData.length > 0) {
    for (var i = 0; i < getAssessmentReportByEmpIDData.length; i++) {
      let detail = getAssessmentReportByEmpIDData[i];

      getAssessmentDimensionsData.push({
        "bucket": detail.bucket,
        "colorCode": detail.colorCode,
        "count": detail.count,
        "dimension": detail.dimension,
        "finalSum": Number(detail.count) * Number(detail.rankSum),
        "rankSum": getWeightage(i + 1)
      });

    }

    getAssessmentDimensionsData.sort((a, b) => a.rankSum - b.rankSum)

  }

  function checkForGeneralship(bucket, dimension) {
    let text = "";
    if (bucket && dimension) {
      if (dimension.toLowerCase() === "generalship" && bucket.toLowerCase() === "thinking talents") {
        text = "old";
      } else if (dimension.toLowerCase() === "enhancer" && bucket.toLowerCase() === "relating talents") {
        text = "old";
      } else if (dimension.toLowerCase() === "coach" && bucket.toLowerCase() === "leading talents") {
        text = "old";
      }
    }
    return text
  }



  function getTopBottomIndex(list, type) {
    let range1 = 0;
    let range2 = 0;
    if (list && list.length > 0) {
      if (type === "top") {
        range1 = 5;
        range2 = 5;
      } else if (type === "mid") {
        range1 = 6;
        range2 = list.length - 5;
      } else if (type === "bottom") {
        range1 = list.length - 4
        range2 = list.length - 4
      }
    }
    return {
      "range1": range1,
      "range2": range2
    }
  }




  return (
    <>
      <section className="w-full px-4 py-2 mx-auto xl:w-11/12 xl:px-0">
        {!backSummary ?
          <div dir="rtl" className="w-full mx-auto space-y-6 ">
            <div className="mt-6 space-y-2 text-base font-normal text-right md:space-y-6 text-white/80">
              <h1 className="py-2 text-2xl font-medium md:text-4xl text-white/100" style={{ color: getTheme('text', '#FFFFFF') }}>
                {EditButtonFn('TalentAssessmentSummary', "TalentPlus Assessment Summary")}
              </h1>
              <h1 className="text-base font-medium text-white md:text-lg " style={{ color: getTheme('text', '#FFFFFF') }}>
                {EditButtonFn('TalentAssessmentDesc', `Talents are our natural ways of thinking, feeling, and behaving.
              They define how we do what we do. Talents are core to our being.
              Successful people know their talents and are able to utilise it
              beautifully for the work they do and success they achieve. Knowing
              your talents allows you to experience flow at work and produces
              superior performance. Your talents make you unique and allows you
              to stand out amongst others. It also makes you authentic and
              allows you to lead a fulfilling and happy life by being who you
              are and not trying to be someone else`)}
              </h1>
            </div>

            <div className="items-center justify-between p-4 space-y-4 bg-white border md:p-8 rounded-xl xl:flex lg:space-y-0">
              <div className="flex items-center space-x-2">
                <div className="w-16 2xl:w-28 xl:w-24">
                  <img
                    // src="https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                    src="img/icon/user.png"
                    className="object-cover "
                  />
                </div>

                <div className="p-2 space-y-2 ">
                  <h1 className="text-xl font-medium text-gray-700 md:text-2xl">
                    {crrSelectedEmp && crrSelectedEmp.name
                      ? crrSelectedEmp.name
                      : ""}
                  </h1>
                  {/* <p className="text-sm font-medium md:text-lg text-slate-500">
                  {crrSelectedEmp && crrSelectedEmp.email
                    ? crrSelectedEmp.email
                    : ""}
                </p> */}
                </div>
              </div>
              <div className="p-2 space-y-2 ">
                <p className="text-base font-medium md:text-lg text-slate-500">
                  {EditButtonFn('SurveyTakenOn', "Survey Taken On")}:
                </p>
                <h1 className="text-xl font-medium text-gray-700 md:text-2xl">
                  {createdAt}
                </h1>
              </div>

              <div className="flex flex-col justify-end gap-4 md:flex-row ">


                <button
                  onClick={() => handleReport(2)}
                  className="lg:w-56 w-full text-base font-medium rounded-md  inline-flex items-center justify-center px-2 py-4 cursor-pointer bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden">
                  <span class="material-symbols-outlined mr-2 text-[1.5rem]">
                    assignment
                  </span>
                  <span className="transition-all duration-300 ease-out bg-white rounded-full opacity-10"></span>
                  {EditButtonFn('ViewReport', "View Report")}
                </button>


              </div>
            </div>

            <div className="space-y-6 lg:flex lg:space-x-6 lg:space-y-0">
              <Summary
                getAssessmentDimensionsData={getAssessmentReportByEmpIDData}
                EditButtonFn={EditButtonFn}
                EditDetailsFn={EditDetailsFn}
              />
            </div>

            <div className="space-y-6 lg:flex lg:space-x-6 lg:space-y-0 ">
              <div className="lg:w-[30%] w-full">
                <div className="w-full p-4 space-y-6 bg-white border md:p-8 rounded-xl">
                  <div className="pb-4 border-b ">
                    <h1 className="text-xl font-bold text-gray-800 md:text-2xl">
                      {EditButtonFn('domain_4_text', "Domains Key of TALENTPLUS")}
                    </h1>
                  </div>

                  <div className="w-full space-y-4">
                    <div className="flex items-start w-full space-x-2 space-y-2">
                      <div className="space-y-2 text-md">
                        <div className="flex items-center mr-2 text-base font-bold">
                          <p
                            className="w-4 h-4 mb-1 mr-2 text-lg bg-red-500"
                            style={{ background: "#FFC107" }}
                          />
                          {EditButtonFn('THINKINGTALENTS', "THINKING TALENTS")}
                        </div>
                        <p className="text-base text-slate-600">
                          {EditButtonFn(
                            "THINKINGDESC",
                            "These are the talents which define your way of thinking and making a sense of the world. Using these talents, you deliberate on ideas, possibilities, and next course of action. This theme deals with intellectual abilities which is the hallmark of human progress. Thinking about themes allows us to explore our past and gaze into the future so that we can plan things in the present. Thinking talents are the strategic pathway to our future."
                          )}
                        </p>
                      </div>
                    </div>
                    <br />
                    <div className="flex items-start w-full space-x-2 space-y-2">
                      <div className="space-y-2">
                        <div className="flex items-center mr-2 text-base font-bold">
                          <p
                            className="w-4 h-4 mb-1 mr-2 text-lg bg-red-500"
                            style={{ background: "#4CAF50" }}
                          />
                          {EditButtonFn('RELATINGTALENTS', "RELATING TALENTS")}
                        </div>
                        <p className="text-base text-slate-600">
                          {EditButtonFn(
                            "RELATINGDESC",
                            "Human beings are social animals. We thrive with others. We need others in life to share our successes, miseries, and our condition. The ability to connect with others is what defines the possibilities of our success in life. It is the bond between one person and another, which takes us higher and ensures we come together to achieve the goals we set for ourselves, challenges we want to overcome and write history together."
                          )}
                        </p>
                      </div>
                    </div>
                    <br />
                    <div className="flex items-start w-full space-x-2 space-y-2">
                      <div className="space-y-2">
                        <span className={"w-5 h-5 rounded-full "} />
                        <div className="flex items-center mr-2 text-base font-bold">
                          <p
                            className="w-4 h-4 mr-2 bg-red-500"
                            style={{ background: "#2196F3" }}
                          />
                          {EditButtonFn('ACTINGTALENTS', "ACTING TALENTS")}
                        </div>
                        <p className="text-base text-slate-600">
                          {EditButtonFn(
                            "ACTINGDESC",
                            "These are action talents, which allow you to make things happen. Ideas are good but the real progress takes place when we put these ideas to action. The acting talent allows us to put our thoughts into action and see the magic happen. It is these themes which make things happen and lets everyone see the progress happening. Our acting talents ensure that we make progress and finish tasks and achieve things consistently."
                          )}
                        </p>
                      </div>
                    </div>
                    <br />
                    <div className="flex items-start w-full space-x-2 space-y-2">
                      <div className="space-y-2">
                        <span
                          style={{ background: "#673AB7" }}
                          className={"w-5 h-5 rounded-full "}
                        />
                        <div className="flex items-center mr-2 text-base font-bold">
                          <p
                            className="w-4 h-4 mr-2 bg-red-500"
                            style={{ background: "#673AB7" }}
                          />
                          {EditButtonFn('LEADINGTALENTS', "LEADING TALENTS")}
                        </div>
                        <p className="text-base text-slate-600">
                          {EditButtonFn(
                            "LEADINGDESC",
                            "These are the talents, which defines our leadership. Leadership is not a position but it is a mindset, through which people share their vision with others, get them aligned and motivated and ensure work takes place towards that desired future. Leaders are the people responsible for a better tomorrow, so they not only have to keep looking at the things to come but also make that dream a reality with the help of others."
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:w-[70%] w-full space-y-6">
                <div className="flex items-center justify-between w-full p-4 bg-white border md:p-8 rounded-xl">
                  <div className="w-full space-y-4">
                    {getAssessmentReportByEmpIDData &&
                      getAssessmentReportByEmpIDData.length > 0
                      ? getAssessmentReportByEmpIDData.map((element, index1) => ((index1 + 1 <= getTopBottomIndex(getAssessmentReportByEmpIDData, "top").range1) ?
                        <>
                          {index1 + 1 === 1 ? (
                            <div className="space-y-4 ">
                              <h1 className="text-xl font-bold text-gray-800 md:font-semibold md:text-2xl">
                                {EditButtonFn('DominantThemes', "Dominant TalentPlus theme")}
                              </h1>
                              <p className="text-base">
                                {EditButtonFn('YourTop5TalentPlustheme', "Your Dominant TalentPlus theme: (Broadly they define who you are what makes you successful, they need tobe understood, nurtured and used regularly to experience a thriving life)")}
                              </p>
                            </div>
                          ) : null}

                          {(index1 + 1 <= getTopBottomIndex(getAssessmentReportByEmpIDData, "top").range1) ? (
                            <>
                              <div
                                onClick={() => handleShowMainSummaryModal(element, 2)}
                                style={{
                                  background: hexToRgbA(
                                    element && element.colorCode
                                      ? element.colorCode
                                      : "#DDDDDD",
                                    "0.20"
                                  ),
                                }}
                                className={
                                  "cursor-pointer rounded-2xl 2xl:px-8 md:py-4 p-4 md:flex justify-between  items-center md:space-x-6 md:space-y-0 space-y-4 "
                                }
                              >
                                <div className="2xl:space-y-4 space-y-2 md:w-[30%]">
                                  <button
                                    style={{
                                      background:
                                        element && element.colorCode
                                          ? element.colorCode
                                          : "#DDDDDD",
                                    }}
                                    className={
                                      " px-4 py-2 2xl:text-sm text-xs font-medium flex text-white uppercase tracking-widest  rounded-full "
                                    }
                                  >
                                    {/* {element.bucket} */}
                                    {EditDetailsFn(element, 'bucket', element.bucket)}
                                  </button>
                                  <h1 className="text-xl font-medium 2xl:text-2xl text-slate-900 md:px-4 ">
                                    {/* {(index1 + 1 > 16
                                      ? (index1 + 1 - 16).toString()
                                      : (index1 + 1).toString()) +
                                      ". " +
                                      element.dimension} */}

                                    {((index1 + 1) > getTopBottomIndex(getAssessmentReportByEmpIDData, "mid").range1 ? (index1 + 1 - getTopBottomIndex(getAssessmentReportByEmpIDData, "mid").range1).toString() : (index1 + 1).toString()) + ". "}{EditDetailsFn(element, 'dimension', element.dimension)}

                                  </h1>
                                </div>

                                <div className="md:w-[70%] flex justify-between space-x-6 md:items-center items-end ">
                                  <p className="flex-1 text-sm font-normal md:text-base text-slate-600 ">
                                    {/* {element &&
                                    element.details &&
                                    element.details.desc
                                      ? element.details.desc
                                      : ""} */}

                                    {EditDetailsFn(element, 'desc', element.details.desc)}
                                  </p>

                                  <div className="w-16 xl:w-28 md:w-20">
                                    <img
                                      src={
                                        "/img/assessment/circleicons/" + (checkForGeneralship(element.bucket, element.dimension)) +
                                        element.dimension.toLowerCase() +
                                        ".svg"
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}
                        </>
                        : null))
                      : null}
                  </div>
                </div>

                <div className="flex items-center justify-between w-full p-4 bg-white border md:p-8 rounded-xl">
                  <div className="w-full space-y-4">
                    {getAssessmentReportByEmpIDData &&
                      getAssessmentReportByEmpIDData.length > 0
                      ? getAssessmentReportByEmpIDData.map((element, index1) => ((index1 + 1 >= getTopBottomIndex(getAssessmentReportByEmpIDData, "bottom").range1) ?
                        <>

                          {index1 + 1 === getTopBottomIndex(getAssessmentReportByEmpIDData, "bottom").range1 ? (
                            <div className="space-y-4 ">
                              <h1 className="text-xl font-bold text-gray-800 md:font-semibold md:text-2xl">

                                {EditButtonFn('NonDominantThemes', "Non Dominant TalentPlus theme")}
                              </h1>
                              <p className="text-base">
                                {EditButtonFn('YourLast5TalentPlustheme', "Your Non Dominant TalentPlus Themes (These are the talents, which are there but not much & you may need tolearn how to manage it to achieve your goals in life)")}

                              </p>
                            </div>
                          ) : null}

                          {(index1 + 1 >= getTopBottomIndex(getAssessmentReportByEmpIDData, "bottom").range1) ? (
                            <>
                              <div
                                style={{
                                  background: hexToRgbA(
                                    element && element.colorCode
                                      ? element.colorCode
                                      : "#DDDDDD",
                                    "0.20"
                                  ),
                                }}
                                className={
                                  "rounded-2xl 2xl:px-8 md:py-4 p-4 md:flex justify-between  items-center md:space-x-6 md:space-y-0 space-y-4 "
                                }
                              >
                                <div className="2xl:space-y-4 space-y-2 md:w-[30%]">
                                  <button
                                    style={{
                                      background:
                                        element && element.colorCode
                                          ? element.colorCode
                                          : "#DDDDDD",
                                    }}
                                    className={
                                      " px-4 py-2 2xl:text-sm text-xs font-medium flex text-white uppercase tracking-widest  rounded-full "
                                    }
                                  >
                                    {/* {element.bucket} */}
                                    {EditDetailsFn(element, 'bucket', element.bucket)}
                                  </button>
                                  <h1 className="text-xl font-medium 2xl:text-2xl text-slate-900 md:px-4 ">
                                    {/* {(index1 + 1 > 16
                                      ? (index1 + 1 - 16).toString()
                                      : (index1 + 1).toString()) +
                                      ". " +
                                      element.dimension} */}
                                    {((index1 + 1) > getTopBottomIndex(getAssessmentReportByEmpIDData, "mid").range2 ? (index1 + 1 - getTopBottomIndex(getAssessmentReportByEmpIDData, "mid").range2).toString() : (index1 + 1).toString()) + ". "}{EditDetailsFn(element, 'dimension', element.dimension)}
                                  </h1>
                                </div>

                                <div className="md:w-[70%] flex justify-between space-x-6 md:items-center items-end ">
                                  <p className="flex-1 text-sm font-normal md:text-base text-slate-600 ">
                                    {/* {element &&
                                    element.details &&
                                    element.details.desc
                                      ? element.details.desc
                                      : ""} */}
                                    {EditDetailsFn(element, 'desc', element.details.desc)}
                                  </p>

                                  <div className="w-16 xl:w-28 md:w-20">
                                    <img
                                      src={
                                        "/img/assessment/circleicons/" + (checkForGeneralship(element.bucket, element.dimension)) +
                                        element.dimension.toLowerCase() +
                                        ".svg"
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}
                        </>
                        : null))
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          : null}


        {backSummary ?
          <>
            <div className="space-y-6 lg:flex lg:space-x-6 lg:space-y-0">
              <BackSummary
                getAssessmentDimensionsData={getAssessmentDimensionsData}
                EditButtonFn={EditButtonFn}
                EditDetailsFn={EditDetailsFn}
                loading={loading}
                handleShowMainSummaryModalBack={handleShowMainSummaryModalBack}
                contactExpertSection={contactExpertSection}
                handleExpertContactModal={handleExpertContactModal}
                topFiveTalent={topFiveTalent}
                handleExpertContactModalBack={handleExpertContactModalBack}
                getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                handleShowMainSummaryModal={handleShowMainSummaryModal}
                crrDetail={crrDetail}
                crrCodeUserDetails={crrCodeUserDetails}
                handleInputExpertForm={handleInputExpertForm}
                bookExpert={bookExpert}
                userAssessmentExpertOrderPlaceData={userAssessmentExpertOrderPlaceData}
                handleTestPayment={handleTestPayment}
                showMyExpertList={showMyExpertList}
                getExpertOrderBookListData={getExpertOrderBookListData}
              />
            </div>
          </> : null
        }


        {/*  */}
      </section>

      <div className="pt-4 ">
        <div className="flex justify-center w-full p-4 bg-white/10">
          <p className="text-sm text-white/80 ">
            © Powered by
            <b className="ml-1 font-medium text-white/100">HappyPlus</b>
          </p>
        </div>
      </div>
    </>
  );
}
